import { configureStore } from '@reduxjs/toolkit'
import preferencesReducer from './slices/preferences'
import syncReducer from './slices/syncSlice'
import templateReducer from './slices/templateSlice'
import logger from 'redux-logger'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const store = configureStore({
  reducer: {
    preferences: persistReducer(
      {
        key: 'preferences',
        storage,
        blacklist: ['loadStore'], // Don't persist temporary canvas load data
      },
      preferencesReducer
    ),
    sync: syncReducer, // Non-persisted sync state
    template: templateReducer, // Template state
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(logger),
})

export const persistor = persistStore(store)
export default store